var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("返回")])}
var staticRenderFns = []

export { render, staticRenderFns }